{
  "version": 1,
  "asset_id": "3cffc7d6-84cb-4532-ad6b-fdea5cbd809c",
  "project_id": "8cc9b1c1-0457-40cd-aa82-ea9e6032ce50",
  "url": "/__l5e/assets-v1/3cffc7d6-84cb-4532-ad6b-fdea5cbd809c/hero-wall-of-games.webp",
  "r2_key": "a/v1/8cc9b1c1-0457-40cd-aa82-ea9e6032ce50/3cffc7d6-84cb-4532-ad6b-fdea5cbd809c/hero-wall-of-games.webp",
  "original_filename": "hero-wall-of-games.webp",
  "size": 187966,
  "content_type": "image/webp",
  "created_at": "2026-07-04T16:12:54Z"
}
